import { apiClient } from '../client';

/**
 * Client for `/api/cs/agents` (Phase 16 / ADR-026). CS agents ARE hub
 * Memberships — the profile only adds the Chatwoot mapping + CS-only
 * suspension state. Mirrors server/src/routes/cs/agents.routes.ts +
 * modules/cs/agents/profiles.service.ts.
 */

export interface CsAgentProfile {
  id: string;
  organizationId: string;
  membershipId: string;
  chatwootAgentId: number | null;
  isSuspended: boolean;
  suspendedAt: string | null;
  suspendedByMembershipId: string | null;
  suspensionReason: string | null;
  lastCsActivityAt: string | null;
  createdAt: string;
  updatedAt: string;
  membership: {
    id: string;
    role: string;
    user: { id: string; email: string; firstName: string; lastName: string };
  };
}

export async function listCsAgents(): Promise<CsAgentProfile[]> {
  const res = await apiClient.get<{ data: CsAgentProfile[] }>('/api/cs/agents');
  return res.data.data;
}

export async function createCsAgent(input: {
  membershipId: string;
  chatwootAgentId?: number | null;
}): Promise<CsAgentProfile> {
  const res = await apiClient.post<{ data: CsAgentProfile }>('/api/cs/agents', input);
  return res.data.data;
}

export async function suspendCsAgent(profileId: string, reason?: string): Promise<CsAgentProfile> {
  const res = await apiClient.post<{ data: CsAgentProfile }>(
    `/api/cs/agents/${encodeURIComponent(profileId)}/suspend`,
    reason ? { reason } : {},
  );
  return res.data.data;
}

export async function unsuspendCsAgent(profileId: string): Promise<CsAgentProfile> {
  const res = await apiClient.post<{ data: CsAgentProfile }>(
    `/api/cs/agents/${encodeURIComponent(profileId)}/unsuspend`,
    {},
  );
  return res.data.data;
}

/** Removes the CS-side profile only — never the hub Membership. */
export async function deleteCsAgent(profileId: string, reason?: string): Promise<void> {
  await apiClient.delete(`/api/cs/agents/${encodeURIComponent(profileId)}`, {
    ...(reason ? { data: { reason } } : {}),
  });
}
